/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './DeleteButton.scss'
import React, { Component } from 'react'
import Button from './Button'

class DeleteButton extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      isDialogClosed: true,
      positionRight: this.calculatePosition(props.width)
    }
  }

  calculatePosition(width) {
    const w = width || 90
    const pos = ((256 - w) / 2) * -1
    return pos + 'px'
  }

  onShowDialog() {
    const state = Object.assign({}, this.state)
    state['isDialogClosed'] = false
    this.setState(state)
  }

  onCloseDialog() {
    const state = Object.assign({}, this.state)
    state['isDialogClosed'] = true
    this.setState(state)
  }

  render() {
    const label = this.props.children || '削除する'
    const size = this.props.size || 'lg'
    return (
      <div className={`DeleteButton ${this.props.className || ''}`}>
        {(() => {
          return !this.state.isDialogClosed ? (
            <div className={`DeleteDialog`} style={{ right: this.state.positionRight }}>
              <p>削除しますか？</p>
              <div className="DeleteDialog__Buttons">
                <Button className="DeleteDialog__Cancel" type="dark" size="lg" onClick={() => this.onCloseDialog()}>
                  いいえ
                </Button>
                <Button className="DeleteDialog__Delete" type="danger" size="lg" onClick={e => this.props.onClick(e)}>
                  削除
                </Button>
              </div>
            </div>
          ) : null
        })()}
        <Button className="DeleteButton__Button" type="danger" size={size} onClick={() => this.onShowDialog()}>
          {label}
        </Button>
      </div>
    )
  }
}

export default DeleteButton
